<template>
<div class="d-flex flex-nowrap align-items-center px-1 py-2">
	<div class="px-2">
		<transition name="pick-period-slide-left">
			<pick-period-vidget
				v-if="!showPickPeriod"
				:tiles="pickPeriodVidgetTiles"
				:default-tile-index="tileIndex"
				@period="(from, to, i) => {
					tileIndex = i
					if (i == 0 && isNotAcknowledgeEvents) {
						onNotAcknowledgeEvents()
					} else {
						showAcknowledgeButton = false
						timeFrom = from
						timeTo = to
					}
				}"
				:disabled="isLoading"
			/>
		</transition>
	</div>
	<div class="px-0 d-flex align-items-center">
		<button
			type="button"
			data-bs-toggle="button"
			:aria-pressed="showPickPeriod"
			class="btn btn-sm btn-outline-secondary"
			:disabled="isLoading"
			@click.stop="onPickPeriod()"
		>
			довільно
		</button>
	</div>
	<div
		v-if="isNotAcknowledgeEvents"
		class="px-2 d-flex align-items-center"
	>
		<button
			v-show="showAcknowledgeButton"
			type="button"
			data-bs-toggle="button"
			:aria-pressed="showPickPeriod"
			class="btn btn-sm btn-outline-success text-nowrap"
			:disabled="isLoading"
			@click.stop="onAcknowledgeEvents()"
		>
			Позначити переглянутими
		</button>
	</div>

	<div
		v-if="
			tableStats.rowsCount >= tableRowsPerPage
			&& tableStats.oldestTime instanceof Date
			&& tableStats.newestTime instanceof Date
		"
		class="ms-0 me-auto px-2 d-flex text-warning text-nowrap"
	>
		Показано {{ tableStats.displayedRowsCount }} з {{ tableStats.rowsCount }} рядків, 
		в період часу з {{ dateTimeToString(tableStats.oldestTime, false) }} по {{ dateTimeToString(tableStats.newestTime, false) }}.
	</div>

	<div class="ms-auto px-2 d-flex align-items-center">
		<transition name="pick-period-slide-right">
			<from-to-period-form
				v-if="showPickPeriod"
				:defaultFrom="timeFrom"
				:defaultTo="timeTo"
				:disabled="isLoading"
				@submit="(from, to) => {
					timeFrom = from
					timeTo = to
				}"
			/>
		</transition>
	</div>

	<div v-if="isAboutPopUp" class="px-0 d-flex align-items-center">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm m-0 rounded-circle"
			@click="showAbout = true"
			style="border: 0px;"
		>
			<button-icon icon="question" fill="currentColor"/>
		</button>
	</div>
</div>

<div class="row m-0 p-0 px-1">
	<events-table
		:station-ids="stationIds"
		:time-from="timeFrom"
		:time-to="timeTo"
		:events-filter="eventsFilter"
		:height="tableHeight"
		:rows-per-page="tableRowsPerPage"
		@is-loading="(v) => isLoading = v"
		@table-stats="(stats) => tableStats = stats"
	/>
</div>

<!-- About pop-up -->
<pop-up-modal
	v-model:show="showAbout"
	size="modal-xl"
	title="Як користуватись журналои подій"
	rejectButtonTitle="Закрити"
	@reject="showAbout = false"
>
	<template v-slot:body>
		<events-section-about />
	</template>
</pop-up-modal>
</template>




<script>
import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import FromToPeriodForm from '@/components/FromToPeriodForm.vue'
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'
import PopUpModal from '@/components/PopUpModal.vue'
import EventsSectionAbout from './EventsSectionAbout.vue'
import EventsTable from './EventsTable.vue'
import { useRoute, useRouter, } from 'vue-router'
import { useAccontStore } from '@/stores/AccountStore.js'
import {
	subtractHoursFromNowDate,
	periodDays,
	dayEnd,
	dayStart,
	dateTimeToString,
} from '@/helpers.js'


export default {
	components: {
		PickPeriodVidget,
		FromToPeriodForm,
		ButtonIcon,
		PopUpModal,
		EventsSectionAbout,
		EventsTable,
	},

	props: {
		stationIds: {
			type: Array,
			require: false,
			default: new Array(),
		},

		// Which events to show (for events list look to EventsTable.vue props)
		eventsFilter: {
			type: Array,
			require: false,
			// Show all event by default
			default: undefined,
		},

		tableHeight: {
			type: Number,
			require: false,
			default: undefined,
		},
		
		isNotAcknowledgeEvents: {
			type: Boolean,
			require: false,
			default: true,
		},

		isAboutPopUp: {
			type: Boolean,
			require: false,
			default: true,
		},
	},

	setup(props) {
		const tableRowsPerPage = 500
		const accountStore = useAccontStore()
		const lastVisitTime = subtractHoursFromNowDate(12)
		const pickPeriodVidgetTiles = [
			...(props.isNotAcknowledgeEvents ? [['не переглянуто', undefined],] : []),
			['24 год', 1],
			['тиждень', 7],
			['місяць', 30],
			// ['3 місяці', 90],
			// ['6 місяців', 180],
			// ['рік', 365],
			// ['5 років', 365 * 5],
		]
		const route = useRoute()
		const router = useRouter()

		return {
			tableRowsPerPage,
			periodDays,
			dateTimeToString,
			accountStore,
			lastVisitTime,
			pickPeriodVidgetTiles,
			route,
			router,
		}
	},

	data() {
		return {
			// Table feedback values
			isLoading: true, // is data loading
			tableStats: {},

			showPickPeriod: false,
			tileIndex: 0, // default tile
			timeFrom: new Date(),
			timeTo: new Date(),
			showAbout: false,
			showAcknowledgeButton: false,
		}
	},
	
	watch: {
		showPickPeriod() {
			this.setUrlParms()
		},

		timeFrom() {
			this.setUrlParms()
		},

		timeTo() {
			this.setUrlParms()
		},
	},

	async created() {
		this.getUrlParms()
	},

	methods: {
		onPickPeriod() {
			this.showPickPeriod = !this.showPickPeriod
			this.showAcknowledgeButton = false
		},

		onNotAcknowledgeEvents() {
			this.showAcknowledgeButton = true
			this.timeFrom = this.accountStore.eventsAcknowledgeTime ?? dayStart(new Date())
			this.timeTo = dayEnd(new Date())
		},

		onAcknowledgeEvents() {
			this.accountStore.acknowledgeEvents()
			this.showAcknowledgeButton = false
		},

		setUrlParms() {
			let newQuery = {}

			newQuery = this.showPickPeriod
				? { from: this.timeFrom.toISOString(), to: this.timeTo.toISOString() }
				: { tile: this.tileIndex }

			this.router.replace({
				name: this.$route.name,
				params: this.$route.params,
				query: newQuery,
			}).catch(err => {
				console.error("Error on replace route: ", err, ".")
			})
		},

		getUrlParms() {
			const parseDate = (value) => {
				if (typeof value !== 'string') {
					return null
				}

				const date = new Date(value)
				return Number.isNaN(date.getTime()) ? null : date
			}

			const query = this.route.query ?? {}
			const from = parseDate(query.from)
			const to = parseDate(query.to)

			if (from && to) {
				this.showPickPeriod = true
				this.timeFrom = from
				this.timeTo = to
				return
			}

			this.showPickPeriod = false
			const rawTile = Number.parseInt(query.tile, 10)
			this.tileIndex = Number.isInteger(rawTile)
				&& rawTile >= 0
				&& rawTile < this.pickPeriodVidgetTiles.length
				? rawTile
				: 0
		},
	},

	computed: {},
}
</script>




<style scoped>
.pick-period-slide-left-enter-active,
.pick-period-slide-left-leave-active {
	transition: transform 0.5s ease, opacity 0.5s ease;
}

.pick-period-slide-left-enter-from,
.pick-period-slide-left-leave-to {
	transform: translateX(-24px);
	opacity: 0;
}

.pick-period-slide-left-enter-to,
.pick-period-slide-left-leave-from {
	transform: translateX(0);
	opacity: 1;
}

.pick-period-slide-right-enter-active,
.pick-period-slide-right-leave-active {
	transition: transform 0.5s ease, opacity 0.5s ease;
}

.pick-period-slide-right-enter-from,
.pick-period-slide-right-leave-to {
	transform: translateX(24px);
	opacity: 0;
}

.pick-period-slide-right-enter-to,
.pick-period-slide-right-leave-from {
	transform: translateX(0);
	opacity: 1;
}
</style>